import { createContext, useState } from 'react';

export const ApparelContext = createContext();

export const ApparelProvider = ({ children }) => {
  const [apparelFlow, setApparelFlow] = useState([]);

  const addApparelType = (name, variants) => {
    if (apparelFlow.find(item => item.name === name)) return;
    // add new apparel type to flow while setting all other apparel types to inactive
    setApparelFlow([
      ...apparelFlow.map(item => ({ ...item, active: false })),
      { name, designNums: [], variants, selectedVariants: [], active: true },
    ]);
  };

  const removeApparelType = name => {
    const updatedFlow = apparelFlow.filter(item => item.name !== name);
    setApparelFlow(updatedFlow);
  };

  const setApparelActive = name => {
    const updatedFlow = apparelFlow.map(item =>
      item.name === name ? { ...item, active: true } : item
    );
    setApparelFlow(updatedFlow);
  };

  const setApparelInactive = name => {
    const updatedFlow = apparelFlow.map(item =>
      item.name === name ? { ...item, active: false } : item
    );
    setApparelFlow(updatedFlow);
  };

  const addDesignNum = (name, num) => {
    // find the object in apparelFlow with the name
    // add the num to the designNums array
    const updatedFlow = apparelFlow.map(item =>
      item.name === name
        ? { ...item, designNums: [...item.designNums, num] }
        : item
    );
    setApparelFlow(updatedFlow);
  };

  const removeDesignNum = (name, num) => {
    const updatedFlow = apparelFlow.map(item => {
      if (item.name === name) {
        const index = item.designNums.indexOf(num);
        if (index === -1) return item;
        const newDesignNums = [...item.designNums];
        newDesignNums.splice(index, 1);
        return { ...item, designNums: newDesignNums };
      }
      return item;
    });
    setApparelFlow(updatedFlow);
  };

  const removeApparelItem = name => {
    const updatedFlow = apparelFlow.filter(item => item.name !== name);
    setApparelFlow(updatedFlow);
  };

  const setActiveVariants = (name, variant) => {
    const updatedFlow = apparelFlow.map(item =>
      item.name === name ? { ...item, selectedVariants: variant } : item
    );
    setApparelFlow(updatedFlow);
  };

  const activeApparelType = apparelFlow.find(item => item.active);

  const totalSelectedDesignNums = apparelFlow.reduce(
    (acc, item) => acc + item.designNums.length,
    0
  );

  return (
    <ApparelContext.Provider
      value={{
        apparelFlow,
        addApparelType,
        removeApparelType,
        addDesignNum,
        removeDesignNum,
        removeApparelItem,
        setApparelActive,
        setApparelInactive,
        activeApparelType,
        setActiveVariants,
        totalSelectedDesignNums,
      }}
    >
      {children}
    </ApparelContext.Provider>
  );
};
